import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// 1. Import Global Styles
import './index.css';

// 2. Import Protected Route
import ProtectedRoute from './components/ProtectedRoute';

// 3. Import Layout
import Layout from './pageLayout/Layout';

// 4. Import Pages
import Dashboard from './pages/Dashboard';
import DataEntry from './pages/DataEntry';
import Prediction from './pages/Prediction';
import AdminDashboard from './pages/AdminDashboard';
import { AlertProvider } from './context/AlertContext';

function App() {
    return (
        <AlertProvider>
            <BrowserRouter>
                <Routes>
                    {/* Protected Dashboard */}
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Dashboard />} />
                    </Route>

                    {/* Protected routes - auth required */}
                    <Route
                        path="/dataentry"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<DataEntry />} />
                    </Route>

                    <Route
                        path="/prediction"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Prediction />} />
                    </Route>

                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute allowedRoles={['AGM', 'Administrator']}>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<AdminDashboard />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AlertProvider>
    );
}

export default App;